import type React from 'react';

import { Button, Logo, Text } from '@change/ds-core-ui';

import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';
import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import type { LandingPageSlug } from '#src/app/pages/landing/template/pageContext';

type Props = {
	slug: LandingPageSlug;
	onCtaClick: () => void;
};

export const Header: React.FC<Props> = ({ onCtaClick, slug }) => {
	const { translate } = useI18n();
	const getStaticAssetUrl = useGetStaticAssetUrl();

	return (
		<div className="relative">
			<div className="absolute top-2 left-0 w-full md:top-6">
				<div className="container">
					<div className="flex items-center">
						<Logo
							variant="logo"
							color="inverse"
							size="large"
							ariaLabel={translate('corgi.components.logo.change_org')}
						/>
						<Text className="text-typography-inverse-strong md:text-size-body-xl ml-2" as="span" size="medium">
							<Translate value={`landing.${slug}.logo_header`} />
						</Text>
					</div>
				</div>
			</div>
			<div
				className="h-[334px] w-full bg-cover bg-center bg-no-repeat md:h-[576px]"
				style={{ backgroundImage: `url(${getStaticAssetUrl(translate(`landing.${slug}.assets.hero`))})` }}
			/>
			<div className="px-4 md:px-16">
				<div className="rounded-medium bg-background-raised mx-auto -mt-[140px] max-w-[330px] px-6 py-4 md:-mt-[240px] md:max-w-[775px] md:px-16 md:py-8">
					<Text as="h1" variant="heading" size="large" className="text-center">
						<Translate value={`landing.${slug}.cta_header.title`} />
					</Text>
					<Text as="p" size="large" className="md:text-size-body-xl mt-[15px] text-center">
						<Translate value={`landing.${slug}.cta_header.body`} />
					</Text>
					<div className="flex flex-col items-center justify-center">
						<Button
							as="a"
							href={`/start-a-petition/intro?source_location=${slug}_landing_page`}
							onClick={onCtaClick}
							variant="primary"
							className="mt-10 w-full md:w-[322px]"
						>
							<Translate value={`landing.${slug}.cta_header.button`} />
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};
